import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Pfunctarg(){

    const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
     <div>
<Sides/>
<Helmet>
 
  <title>Learn Free Python Function arguement Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python function argument tutorial for beginners.function argument is an argument may be a variable or a constant value that can be used () of a function." />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,python function argument,python function as argument,python function arguments,python function arguments list,python function arguments type,python function argument type check,python function argument list
,python 3 function argument type,* in python function argument,python function argument order" />
<link rel="canonical" href="https://www.codeexampler.com/python-function-argument" />
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">Function argument in python</h1>

    <div className="first">
        <a href="/python-function"><Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-function-overloading"><Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

    <p className="mt-4 para">The function argument is an argument that may be a variable or a constant value that can uses () of a function.</p>

<h2 className="mt-4 mh2">Types of argument in function argument:</h2>
<h3 className="mt-4 mh3">1, Default argument in function argument<br/>
2, keyword argument in function argument<br/>
3, arbitrary argument in function argument<br/>
</h3>

<h2 className="mt-4 mh2">Simple function argument example:</h2>



<h2 className='headings'>Q-Write a Program Input Name function arguement example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty">def </span>
                 <span className="qwerty-8">Type_names</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
                 <span className="qwerty-5"> # x is an arguement</span>
                 {"\n"}
                 <span className="qwerty-3">    print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">my name is </span>
                 <span className="qwerty-6">%s</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-4">%x</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-4">name</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">input</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">Enter your name</span>
                 <span className="qwerty-1">")</span>
                 {"\n"}
                 <span className="qwerty-8">Type_names</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">name</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-2">Enter your name </span>
                         <span className="qwerty-3">Code Exampler</span>
                     {"\n"}
                         <span className="qwerty-8">my name is </span>
                         <span className="qwerty-3">Code Exampler</span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>



<h2 className='headings'>Q-Write a Program Odd/Even function arguement example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty">def </span>
                 <span className="qwerty-8">Check</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">n</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty-6">    if</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">n</span>
                 <span className="qwerty">%</span>
                 <span className="qwerty-2">2</span>
                 <span className="qwerty">==</span>
                 <span className="qwerty-2">0</span>
                 <span className="qwerty-1">):</span>
                 {"\n"}
                 <span className="qwerty-3">        print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">EVEN</span>
                 <span className="qwerty-1">")</span>
                 {"\n"}
                 <span className="qwerty-6">    else</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty-3">        print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">ODD</span>
                 <span className="qwerty-1">")</span>
                 {"\n"}
                 <span className="qwerty-4">no</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-5">int</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">input</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-10">Enter a no</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-8">Check</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">no</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-2">Enter a no </span>
                         <span className="qwerty-3">42</span>
                     {"\n"}
                         <span className="qwerty-4">EVEN</span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>



<h2 className='headings'>Q-Multiply and Table Counting for I range function argument Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty">def </span>
                 <span className="qwerty-8">table</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">n</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty-7">    for </span>
                 <span className="qwerty-10">i </span>
                 <span className="qwerty-5">in </span>
                 <span className="qwerty-6">range</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">1</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">11</span>
                 <span className="qwerty-1">):</span>
                 {"\n"}
                 <span className="qwerty-3">        print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">n</span>
                 <span className="qwerty">*</span>
                 <span className="qwerty-10">i</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-4">n</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-5">int</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">input</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-10">Enter a no</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-8">table</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">n</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-2">Enter a no </span>
                         <span className="qwerty-3">8</span>
                     {"\n"}
                         <span className="qwerty-4">8</span>
                     {"\n"}
                         <span className="qwerty-4">16</span>
                     {"\n"}
                         <span className="qwerty-4">24</span>
                     {"\n"}
                         <span className="qwerty-4">32</span>
                     {"\n"}
                         <span className="qwerty-4">40</span>
                     {"\n"}
                         <span className="qwerty-4">48</span>
                     {"\n"}
                         <span className="qwerty-4">56</span>
                     {"\n"}
                         <span className="qwerty-4">64</span>
                     {"\n"}
                         <span className="qwerty-4">72</span>
                     {"\n"}
                         <span className="qwerty-4">80</span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>

<h2 className="mt-4 mh2">Default argument in function argument: </h2>
<p className="mt-4 para">It must be on the right side more than one default argument.</p>



<h2 className='headings'>Q-Adding function argument in Python example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty">def </span>
                 <span className="qwerty-8">add</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">100</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span  className="qwerty-2">    c </span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-4">b</span>
                 {"\n"}
                 <span className="qwerty">    return </span>
                 <span className="qwerty-2">c</span>
                 {"\n"}
                 <span className="qwerty-4">x </span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-8">add</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">10</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">20</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-4">x </span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-8">add</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">50</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                        <span className="qwerty-8">30</span>
                     {"\n"}
                         <span className="qwerty-3">150</span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>




<h2 className='headings'>Q-Name and Msg in Keyword argument in a function arguement example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty">def </span>
                 <span className="qwerty-8">hello</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">name</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">msg</span>
                 <span className="qwerty-1"> = (</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-10">good morning</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty-3">    print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">hello</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-4">name</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-4">msg</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-8">hello</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-10">Rahul</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-10">good luck</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-8">hello</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-10">Ram</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-5"> # keyword arguement</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-2">hello </span>
                         <span className="qwerty-3">Rahul </span>
                         <span className="qwerty-3">good luck </span>
                     {"\n"}
                         <span className="qwerty-2">hello </span>
                         <span className="qwerty-3">Ram </span>
                         <span className="qwerty-8">good morning </span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>


<h2 className="mt-4 mh2">The arbitrary argument in function argument</h2>

<p className="mt-4 para">Function argument symbol uses with an argument that contains more than one argument.</p>



<h2 className='headings'>Q-Table Counting for i range Arbitary arguement in a function arguement Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty">def </span>
                 <span className="qwerty-8">hello</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty">*</span>
                 <span className="qwerty-4">str</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty-7">    for </span>
                 <span className="qwerty-2">i </span>
                 <span className="qwerty-5">in </span>
                 <span className="qwerty-4">str</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty-3">        print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">hello</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-2">i</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-8">hello</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-10">Ram</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-10">Lakshman</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-10">Bharat</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-10">Shatrughna</span>
                 <span className="qwerty-6">"</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-2">hello </span>
                         <span className="qwerty-3">Ram</span>
                     {"\n"}
                         <span className="qwerty-2">hello </span>
                         <span className="qwerty-3">Lakshman</span>
                     {"\n"}
                         <span className="qwerty-2">hello </span>
                         <span className="qwerty-3">Bharat</span>
                     {"\n"}
                         <span className="qwerty-2">hello </span>
                         <span className="qwerty-3">Shatrughna</span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>




<h2 className='headings'>Q-Arbitary argument in a Python function argument Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty">def </span>
                 <span className="qwerty-8">fun</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty-2">  add</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-4">b</span>
                 {"\n"}
                 <span className="qwerty-2">  mult</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty">*</span>
                 <span className="qwerty-4">b</span>
                 {"\n"}
                 <span className="qwerty">  return </span>
                 <span className="qwerty-2">add</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">mult</span>
                 {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-8">fun</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-10">10</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-10">20</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-1">(</span>
                         <span className="qwerty-8">30</span>
                         <span className="qwerty-1">,</span>
                         <span className="qwerty-8">200</span>
                         <span className="qwerty-1">)</span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>


  <h1 className="mt-5">  </h1>
     
  <div className="back">
        <a href="/python-function">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-function-overloading">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Pfunctarg;